if (window.URLBuild) {
    // eslint-disable-next-line camelcase,no-undef
    __webpack_public_path__ = `${window.URLBuild}/`;
}